/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'watch': {
    width: 16,
    height: 16,
    viewBox: '0 0 43 75.2',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M42.5 26.24c0-.47.08-1.32-.93-1.32h-.39v-1.55a9.45 9.45 0 0 0-6.34-8.89c-1.37-1-1.51-3.08-1.51-5.5V7.11c0-3.19-2.18-5.37-5.76-6A39.8 39.8 0 0 0 20.8.5a38.65 38.65 0 0 0-6.8.62c-3.58.7-5.76 3-5.76 6V9c0 2.45-.07 4.54-1.56 5.54A9.46 9.46 0 0 0 .5 23.37v28.46a9.39 9.39 0 0 0 6.22 8.86c1.42 1 1.56 3.09 1.56 5.53v1.87c0 3.19 2.18 5.37 5.76 6a39.8 39.8 0 0 0 6.77.62 38.64 38.64 0 0 0 6.77-.62c3.58-.7 5.76-3 5.76-6v-1.87c0-2.41.07-4.47 1.49-5.49a9.45 9.45 0 0 0 6.37-8.9V32.7h.39c1 0 .93-.86.93-1.32zM31.4 13.96H10.19M10.2 61.24h21.2"/><path pid="1" class="cls-1" d="M38.61 51.83a6.85 6.85 0 0 1-6.84 6.84H9.91a6.85 6.85 0 0 1-6.84-6.84V23.37a6.85 6.85 0 0 1 6.84-6.84h21.86a6.85 6.85 0 0 1 6.84 6.84z"/><path pid="2" class="cls-1" d="M9.3 42.78h4.44l6.22-13.69 6.77 16.99 2.58-5.01h3.28"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/watch.js